import { FCSelector } from '../../model/form-config.interface';
import {
  CREDIT_PROVISION_ADDITIONAL_CREDIT_BUSINESS_CENTRE,
  CREDIT_PROVISION_FIXING_RATE_TIME,
  CREDIT_PROVISION_FX_PRICE_SOURCE,
  CREDIT_PROVISION_PASS_THROUGH_SECURITIES,
} from './product-capture-field-selectors.consts';

export const PASS_THROUGH_SECURITIES: FCSelector = {
  formControlNames: [CREDIT_PROVISION_PASS_THROUGH_SECURITIES],
  options: [
    {
      id: true,
      effects: [
        {
          formControlNames: [
            CREDIT_PROVISION_FX_PRICE_SOURCE,
            CREDIT_PROVISION_FIXING_RATE_TIME,
            CREDIT_PROVISION_ADDITIONAL_CREDIT_BUSINESS_CENTRE,
          ],
          readOnly: false,
        },
        {
          formControlNames: [
            CREDIT_PROVISION_ADDITIONAL_CREDIT_BUSINESS_CENTRE,
          ],
          selectValues: [false],
          readOnly: false
        },
      ],
    },
    {
      id: false,
      effects: [
        {
          formControlNames: [
            CREDIT_PROVISION_FX_PRICE_SOURCE,
            CREDIT_PROVISION_FIXING_RATE_TIME,
            CREDIT_PROVISION_ADDITIONAL_CREDIT_BUSINESS_CENTRE,
          ],
          readOnly: true,
        },
        {
          formControlNames: [
            CREDIT_PROVISION_FX_PRICE_SOURCE,
            CREDIT_PROVISION_FIXING_RATE_TIME,
            CREDIT_PROVISION_ADDITIONAL_CREDIT_BUSINESS_CENTRE,
          ],
          selectValues: [null],
        },
        {
          formControlNames: [CREDIT_PROVISION_ADDITIONAL_CREDIT_BUSINESS_CENTRE],
          selectValues: [false],
        }
      ],
    },
    {
      id: null,
      effects: [
        {
          formControlNames: [
            CREDIT_PROVISION_FX_PRICE_SOURCE,
            CREDIT_PROVISION_FIXING_RATE_TIME,
            CREDIT_PROVISION_ADDITIONAL_CREDIT_BUSINESS_CENTRE,
          ],
          readOnly: true,
        },
        {
          formControlNames: [
            CREDIT_PROVISION_FX_PRICE_SOURCE,
            CREDIT_PROVISION_FIXING_RATE_TIME,
            CREDIT_PROVISION_ADDITIONAL_CREDIT_BUSINESS_CENTRE,
          ],
          selectValues: [null],
        },
      ],
    },
  ],
};
